import Col from "react-bootstrap/Col"
import styled from "styled-components"

import {spacingCss, SpacingProps} from "../global/css"
import {CompatRow} from "./Row"

export const StyledCol = styled(Col)<SpacingProps>`
  ${spacingCss}
`

export {StyledCol as Col, CompatRow as Row}
export {Grid, default as Container} from "./Grid"

export type {CardProps} from "./Card"
export {default as Card} from "./Card"
export {default as ShadowCard} from "./ShadowCard"
export {default as SvgCard} from "./SvgCard"
export {default as Section} from "./Section"
export {default as Hr} from "./Hr"
export {default as Banner} from "./Banner"
export {default as Dropzone} from "./Dropzone"
export {default as GridCentered} from "./GridCentered"
export type {GridCenteredProps} from "./GridCentered"
